import { render, staticRenderFns } from "./rewardBuildPartnersEdit_bak.vue?vue&type=template&id=80292870&scoped=true&"
import script from "./rewardBuildPartnersEdit_bak.vue?vue&type=script&lang=js&"
export * from "./rewardBuildPartnersEdit_bak.vue?vue&type=script&lang=js&"
import style0 from "./rewardBuildPartnersEdit_bak.vue?vue&type=style&index=0&id=80292870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80292870",
  null
  
)

export default component.exports